import { EVENT_TYPE_LABELS } from './securityConstants';

export function isValidIpAddress(ip) {
  if (!ip || typeof ip !== 'string') return false;
  const trimmed = ip.trim();
  const ipv4 = /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d?\d)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d?\d)$/;
  const ipv6 = /^([0-9a-fA-F]{0,4}:){1,7}[0-9a-fA-F]{0,4}$|^::(?:[0-9a-fA-F]{0,4}:){0,6}[0-9a-fA-F]{0,4}$|^[0-9a-fA-F]{0,4}::(?:[0-9a-fA-F]{0,4}:){0,5}[0-9a-fA-F]{0,4}$/;
  return ipv4.test(trimmed) || ipv6.test(trimmed);
}

export function formatTimestamp(timestamp) {
  return new Date(timestamp).toLocaleString();
}

export function formatMinutesAgo(timestamp) {
  const minutes = Math.floor((Date.now() - new Date(timestamp)) / 60000);
  if (minutes < 1) return 'Just now';
  return `${minutes}m ago`;
}

export function getEventTypeLabel(eventType) {
  return EVENT_TYPE_LABELS[eventType] || eventType;
}

export function getSeverityClass(severity) {
  return `vx-sec-severity-${(severity || '').toLowerCase()}`;
}
